import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon, Modal, message } from 'antd'
import ChangeOnHoldState from './item-actions/ChangeOnHoldState'
import MarkAsDone from './item-actions/MarkAsDone'
import { updateStatusItemEmbroidery } from "../../../../services/api/3dPartnerApi"
import _ from 'lodash'
import ModalEmbroideryInfo from './ModalEmbroideryInfo'

class ItemImage extends Component {
    state = {
        visible: false,
        isModalEmbroidery: false,
        loading: false,
        error: '',
        sideActive: [],
    }

    componentDidCatch(error, errorInfo) {
        console.log("ERROR__", error)
        console.log("ERROR__errorInfo", errorInfo)
    }

    _showModal = (side) => {
        this.setState({
            isModalEmbroidery: true,
            sideActive: [`${side}`]
        })
    }

    _showModalPreview = () => {
        this.setState({
            visible: true,
        })
    }

    _hideModal = () => {
        this.setState({
            isModalEmbroidery: false,
        })
    }

    _hideModalPreview = () => {
        this.setState({
            visible: false,
        })
    }

    _afterDoAction = (status) => {
        this.props.onChangeStatus(status)

        this._hideModalPreview()
    }

    _updateStatusItem = async () => {
        try {
            const { batch = {}, itemNumber, marketplace } = this.props
            const { partner = {} } = batch
            const { code: partnerCode = '' } = partner
            const orderTemplate = `#${marketplace}_${itemNumber}`

            const payload = {
                partnerCode,
                batchItems: [orderTemplate]
            }

            const { success, message: error } = await updateStatusItemEmbroidery(payload)

            if (!success) throw new Error(error)
        } catch (e) {
            message.error(e.message)
        }
    }

    handleActiveSide = (e) => {
        this.setState({
            sideActive: e
        })
    }

    render() {
        const { visible, isModalEmbroidery, sideActive = [] } = this.state
        const {
            image,
            previewImage,
            type,
            size,
            status,
            orderId,
            safezoneImage,
            meta,
            dataType,
            threadColorNote,
            embroidery_area_info = {},
            marketplace,
            itemNumber,
            reloadItems,
            batchItemId,
            productType,
            noteOrder,
        } = this.props
        const { embroidery_sides = [] } = { ...meta }

        const isCMYK = _.get(meta, "infoData.generateOptions.imageOptions.cmyk", false)

        const showSafeZone = (category, dimension) => {
            if (!!safezoneImage) {
                return <img src={safezoneImage} alt="SafeZone" className="Safezone" />
            }
        }

        return (
            <>
                {
                    previewImage ?
                        <div className='Preview position-relative'>
                            <img src={previewImage} className='position-absolute' alt='preview' />
                            {
                                showSafeZone(type, size)
                            }

                            <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                <span className='Icon cursor-pointer mr-2' onClick={() => this._showModalPreview()}><Icon
                                    type='eye' /></span>

                                <a href={image} download className='Icon Download'><Icon type="download" /></a>
                            </div>

                            <Modal visible={visible} closable={false} centered={true} footer={null} width={1200}
                                onCancel={() => this._hideModalPreview()} className='PrintedFileModal mw-1200'>
                                <div className="Previewer">
                                    <img src={previewImage} alt='preview' className='d-block m-auto' />
                                    {
                                        showSafeZone(type, size)
                                    }
                                </div>

                                <div className='bg-light'>
                                    <div className='OrderActions'>
                                        <div className='Actions'>
                                            {
                                                'review' === status &&
                                                <MarkAsDone orderId={orderId} onSuccess={this._afterDoAction} />
                                            }

                                            <ChangeOnHoldState status={status} orderId={orderId}
                                                onChangeStatus={this._afterDoAction} />
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                            {
                                isCMYK &&
                                <div className='cmyk'>CMYK</div>
                            }
                        </div>
                        : image &&
                        <a href={image} target='_blank' rel='noreferrer noopener'
                            className='btn btn-sm text-primary'><u>Download</u></a>
                }
                {
                    embroidery_sides.length > 0 &&
                    <div className="embroidery-area">
                        {
                            embroidery_sides.map((side, index) => {
                                return (
                                    <React.Fragment key={`emb-frag-${side}-${index}`}>
                                        <div key={`embroidery-area-item-${side}-${index}`} className="embroidery-area-item" onClick={() => this._showModal(side)}>
                                            {side}
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </div>
                }
                <ModalEmbroideryInfo
                    threadColorNote={threadColorNote}
                    isOpen={isModalEmbroidery}
                    meta={meta}
                    status={status}
                    embroideryAreaInfo={embroidery_area_info}
                    reloadItems={reloadItems}
                    marketplace={marketplace}
                    itemNumber={itemNumber}
                    dataType={dataType}
                    productType={productType}
                    onStatusItem={this._updateStatusItem}
                    batchItemId={batchItemId}
                    onCancel={this._hideModal}
                    sideActive={sideActive || []}
                    onActiveSide={this.handleActiveSide}
                    noteOrder={noteOrder}
                    display="batch-detail"
                    orderId={orderId}
                />
            </>
        )
    }
}

ItemImage.propTypes = {
    image: PropTypes.string,
    previewImage: PropTypes.string,
    type: PropTypes.string.isRequired,
    size: PropTypes.string,
    safezoneImage: PropTypes.string
}

export default ItemImage
